import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import { Box, Fade, IconButton, Menu, MenuItem } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";
import styles from "../../../styles/Components/SelectInput.module.scss";
import MultipleSelectChip from "./MultipleSelectChip";
import ProjectCategory from "./ProjectCategory";
import ProjectVisibility from "./ProjectVisibility";

export default function ProjectSearchBar({
  onChangeSelect,
  onInputChange,
  handleKeyDown,
  options,
  categoryData,
  onChangeSelectedCategory,
  visibilityData,
  isClearSearch,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [isCategoryDropdownOpen, setIsCategoryDropdownOpen] = useState(false);
  const [isVisibility, setIsVisibility] = useState(false);
  const [isInputOpen, setIsInputOpen] = useState(true);

  const [categoryArr, setCategoryArr] = useState([]);
  const [visibilityArr, setVisibilityArr] = useState([]);
  const [value, setValue] = useState("Title");
  const [inputValue, setInputValue] = useState("");
  const [catArr, setCatArr] = useState([]);

  const onCloseStatus = () => {
    setAnchorEl(null);
    setIsCategoryDropdownOpen(false);
    setIsVisibility(false);
  };

  useEffect(() => {
    setVisibilityArr([]);
    setCatArr([]);
    setCategoryArr([]);
    setInputValue("");
    setValue("Title");
    setIsInputOpen(true);
  }, [isClearSearch]);

  const onPressMenu = (type) => {
    if (type === "category") {
      setValue(type);
      onChangeSelect(type);
      setIsCategoryDropdownOpen(true);
      setIsInputOpen(false);
      setVisibilityArr([]);
      setInputValue("");
      if (categoryArr.length === 0) {
        setCatArr([]);
      }
    } else if (type === "visibility") {
      setValue(type);
      onChangeSelect(type);
      setIsVisibility(true);
      setIsInputOpen(false);
      setCategoryArr([]);
      setInputValue("");
      if (visibilityArr.length === 0) {
        setCatArr([]);
      }
    } else {
      setIsCategoryDropdownOpen(false);
      setIsVisibility(false);
      setValue(type);
      onChangeSelect(type);
      handleClose();
      setIsInputOpen(true);
      setCategoryArr([]);
      setVisibilityArr([]);
      setInputValue("");
      setCatArr([]);
    }
  };

  // Categories
  const selectedCategories = [];
  const selectedCategoryNames = [];
  const onSelectCategoryOption = (id, isChecked, name) => {
    if (isChecked) {
      const idx = selectedCategories.findIndex((ele) => ele === id);
      if (idx === -1) {
        const newArr = [...catArr, id];
        setCatArr(newArr);
        selectedCategories.push(id);
        selectedCategoryNames.push(name);
      }
    } else {
      const idx = catArr.findIndex((ele) => ele === id);
      if (idx !== -1) {
        const oldArr = [...catArr];
        oldArr.splice(idx, 1);
        setCatArr(oldArr);
        selectedCategories.splice(idx, 1);
        selectedCategoryNames.splice(idx, 1);
      }
    }

    const arr1 = [...categoryArr, selectedCategoryNames[0]];
    const uniqueArray = arr1.filter(
      (item, pos) => arr1.indexOf(item) === pos && item !== undefined
    );
    if (!isChecked) {
      const idx = uniqueArray.findIndex((ele) => ele === name);
      if (idx !== -1) {
        uniqueArray.splice(idx, 1);
      }
    }
    setCategoryArr(uniqueArray);
  };

  useEffect(() => {
    onChangeSelectedCategory(catArr);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catArr]);

  // Visibility
  const selectedVisibility = [];
  const onSelectVisibility = (name, isChecked) => {
    if (isChecked) {
      const idx = selectedVisibility.findIndex((ele) => ele === name);
      if (idx === -1) {
        selectedVisibility.push(name);
      }
    } else {
      const idx = selectedVisibility.findIndex((ele) => ele === name);
      if (idx !== -1) {
        selectedVisibility.splice(idx, 1);
      }
    }

    const arr1 = [...visibilityArr, selectedVisibility[0]];
    const uniqueArray = arr1.filter(
      (item, pos) => arr1.indexOf(item) === pos && item !== undefined
    );
    if (!isChecked) {
      const idx = uniqueArray.findIndex((ele) => ele === name);
      if (idx !== -1) {
        uniqueArray.splice(idx, 1);
      }
    }
    setVisibilityArr(uniqueArray);
    onChangeSelectedCategory(uniqueArray);
  };

  const onRemove = (index) => {
    const arr = [];
    if (value === "category") {
      visibilityArr.forEach((item) => {
        const obj = categoryData.find((element) => element.name === item);
        if (obj) {
          arr.push(obj.id);
        }
      });
      setValue("category");
      const oldArr = [...catArr];
      oldArr.splice(index, 1);
      setCatArr(oldArr);
      onChangeSelectedCategory(arr);
    }
    if (value === "visibility") {
      onChangeSelectedCategory(visibilityArr);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.select}>
        <Box
          sx={{
            border: "1px solid #EEEEEE",
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {open ? (
            <IconButton onClick={handleClick}>
              <KeyboardDoubleArrowUpIcon />
            </IconButton>
          ) : (
            <IconButton onClick={handleClick}>
              <KeyboardDoubleArrowDownIcon />
            </IconButton>
          )}
          {isInputOpen ? (
            <Box sx={{ mt: -1 }}>
              <TextField
                value={inputValue}
                onChange={(e) => {
                  onInputChange(e.target.value);
                  setInputValue(e.target.value);
                }}
                onKeyDown={(e) => handleKeyDown(e)}
                placeholder={`Search ${value}`}
                size="small"
                InputProps={
                  {
                    // classes: { notchedOutline: classes.noBorder },
                  }
                }
              />
            </Box>
          ) : (
            <MultipleSelectChip
              selectedVisibility={visibilityArr}
              onRemove={(index, value) => onRemove(index, value)}
              selectedCatgories={categoryArr}
            />
          )}
        </Box>

        {anchorEl && (
          <Menu
            MenuListProps={{
              "aria-labelledby": "fade-button",
            }}
            anchorEl={anchorEl}
            open
            onClose={handleClose}
            TransitionComponent={Fade}
            PaperProps={{ sx: { width: "250px" } }}
          >
            {options &&
              options.map((item, i) => (
                <MenuItem
                  key={`${item.name}_${i}`}
                  onClick={() => onPressMenu(item.name.toLowerCase())}
                >
                  {item.name}
                </MenuItem>
              ))}
          </Menu>
        )}

        <ProjectCategory
          categoryData={categoryData}
          onSelectCategoryOption={onSelectCategoryOption}
          onCloseStatus={onCloseStatus}
          isOpen={isCategoryDropdownOpen}
          dropdownAnchor={anchorEl}
          isDropdownOpen={open}
          selectedData={categoryArr}
        />
        <ProjectVisibility
          categoryData={visibilityData}
          onSelectCategoryOption={onSelectVisibility}
          onCloseStatus={onCloseStatus}
          isOpen={isVisibility}
          dropdownAnchor={anchorEl}
          isDropdownOpen={open}
          selectedData={visibilityArr}
        />
      </div>
    </div>
  );
}
